<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div class="contact-info-page">
    <div class="top-nav">
      <img
        :src="$_LOGOS.BRAND_LOGO_DEFAULT_LIGHT"
        alt
        class="easy-logo"
      >
      <form-button
        :text="$t('APP_TEXT_BACK')"
        class="back"
        icon="SvgArrowDown"
        data-qa="back_button"
        link
        @onClick="goback"
      />
    </div>
    <div class="contact-container">
      <!-- Top Area -->
      <div class="row user-card-top m-0">
        <div class="col-3 col-lg-4 text-center">
          <div class="user-details">
            <svg-icon
              v-if="contact.isfav"
              icon="SvgFavorited"
            />
            <h2>{{ contact.name }}</h2>
            <h3 v-if="contact.title">
              {{ contact.title }}
            </h3>
          </div>
          <div
            v-if="user && !contact.callid"
            class="btn-container"
          >
            <form-button
              type="primary"
              :icon="inContactOperation ? 'SvgLoading' : contact.isMyContact ? 'SvgRemoveUser' : 'SvgAddUser'"
              rounded
              data-qa="add_contact"
              @onClick="toggleContact"
            />
            <h5 v-if="contact.isMyContact">
              {{ $t('APP_TEXT_REMOVE_CONTACT') }}
            </h5>
            <h5 v-else>
              {{ $t('APP_TEXT_ADD_CONTACT') }}
            </h5>
          </div>
          <div
            v-if="user && !contact.callid"
            class="btn-container"
          >
            <form-button
              type="primary"
              :icon="inFavOperation ? 'SvgLoading' : contact.isfav ? 'SvgFavorited' : 'SvgFavorite'"
              rounded
              data-qa="add_favourite"
              @onClick="toggleFav"
            />
            <h5 v-if="contact.isfav || contact.isfav === '1'">
              {{ $t('APP_TEXT_REMOVE_FAVOURITES') }}
            </h5>
            <h5 v-else>
              {{ $t('APP_TEXT_ADD_FAVOURITES') }}
            </h5>
          </div>
        </div>
        <div class="col-6 col-lg-4 profile-pic text-center">
          <!-- User Card Tile -->
          <ContactLiteCard
            :contact="contact"
            data-qa="profile_photo"
          />
        </div>
        <div class="col-3 col-lg-4 p-0">
          <div
            v-if="showContactChatButton"
            class="chat-btn-container"
            @click="gotoChat"
          >
            <div
              v-if="hasNotification"
              class="notify"
            >
              !
            </div>
            <svg-icon icon="SvgChats" />
          </div>
          <div class="call-btn">
            <div class="btn-nav-container">
              <h5 class="label">
                {{ $t('APP_TEXT_CALL') }}
              </h5>
              <template v-if="inMeeting">
                <form-button
                  v-if="contact.isParticipant"
                  icon="SvgCall"
                  class="btn-call btn-danger"
                  rounded
                  @onClick="removeParticipant"
                />
                <form-button
                  v-else
                  type="success"
                  icon="SvgCall"
                  data-qa="call_button"
                  class="btn-call"
                  rounded
                  @onClick="callFromMeeting"
                />
              </template>
              <template v-else>
                <form-button
                  v-if="isOnline"
                  type="success"
                  icon="SvgCall"
                  data-qa="call_button"
                  class="btn-call"
                  rounded
                  @onClick="startCall"
                />
                <form-button
                  v-else
                  icon="SvgCall"
                  class="btn-call"
                  data-qa="call_button"
                  rounded
                  :class="{'btn-danger': isBusy, 'btn-disabled': isOffline}"
                  :disabled="isOffline"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- Bottom Area -->
      <div class="card easy-card-white user-detail-card static">
        <div class="card-body">
          <div class="row">
            <template v-if="contact.iscustom">
              <div
                v-for="device in contact.devices"
                :key="`${contact.id}_${device.id}`"
                class="col-4"
              >
                <form-input
                  type="text"
                  :label="{text:device.type,icon:'SvgE'}"
                  :value="device.number"
                />
              </div>
            </template>
            <template v-else>
              <div class="col-6 col-lg-4">
                <form-input
                  type="email"
                  :label="{text:$t('APP_TEXT_EMAIL'),icon:'SvgEmail'}"
                  righticon="SvgCloseStroke"
                  :value="contact.email"
                />
              </div>
              <div class="col-6 col-lg-4">
                <form-input
                  type="text"
                  :label="{text:$t('APP_TEXT_ROOM'),icon:'SvgE'}"
                  righticon="SvgCloseStroke"
                  :value="contact.room"
                />
              </div>
              <hr class="line">
              <div class="col-6 col-lg-4">
                <form-input
                  type="text"
                  :label="{text:$t('APP_TEXT_PHONE'),icon:'SvgCall'}"
                  righticon="SvgCloseStroke"
                  :value="contact.phone"
                />
              </div>
              <hr class="line">
              <div class="col-6 col-lg-4">
                <form-input
                  type="email"
                  :label="{text:$t('APP_TEXT_ADDRESS'),icon:'SvgGlobe'}"
                  righticon="SvgCloseStroke"
                  :value="contact.address"
                />
              </div>
              <hr class="line">
              <div class="col-6 col-lg-4">
                <form-input
                  type="text"
                  :label="{text:$t('APP_TEXT_COUNTRY'),icon:'SvgLocation'}"
                  righticon="SvgCloseStroke"
                  :value="contact.country"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contact from '@/app/contact';
import ContactLiteCard from '@/components/ContactLiteCard';
export default {
  name: 'Contact',
  components: { ContactLiteCard },
  extends: contact
};
</script>
